'use client';

import { useState } from 'react';
import { FaShareAlt } from 'react-icons/fa';
import SharePopUp from './share-pop-up';
import { useTranslations } from 'next-intl';

export default function ShareButton({ keyword, share }) {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations();

  return (
    <>
      <button
        className="border border-blue-300 flex gap-2 border-primary m-2 p-1 rounded-xl hover:cursor-pointer"
        onClick={() => setIsOpen(true)}
      >
        <FaShareAlt className="my-auto" /> {t('share')}
      </button>
      <SharePopUp isOpen={isOpen} setIsOpen={setIsOpen} keyword={keyword} />
    </>
  );
}
